class HTMLElementWrapper {
  constructor(tagName) {
    this.tagName = tagName;
    this.element = this.createElement();
  }

  createElement() {
    return document.createElement(this.tagName);
  }

  getElement() {
    return this.element;
  }

  getDimensions() {
    return {
      height: this.element.height,
      width: this.element.width,
    };
  }
}

export default HTMLElementWrapper;
